import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { LoaderService } from '../Services/LoaderService/loader.service';

// NOTE: We no longer import MsalService or BroadcastService here.
// The token is injected automatically thanks to the MsalInterceptor configured in app.module.ts

@Injectable()
export class HttpClientInterceptor implements HttpInterceptor {
  private requestCount = 0;

  constructor(private loaderService: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.showLoader();

    // We pass the request as is (the MsalInterceptor will handle the token if necessary)
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          // Successful response handling if needed
        }
      }),
      catchError((err: HttpErrorResponse) => {
        return throwError(err);
      }),
      finalize(() => {
        this.onEnd();
      })
    );
  }

  private onEnd(): void {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0; // Safety to avoid going below zero
      this.hideLoader();
    }
  }

  private showLoader(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.loaderService.show();
    }
  }

  private hideLoader(): void {
    this.loaderService.hide();
  }
}
